import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    top: 40,
    right: 0,
    width: 270,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  selectActions: {
    width: 160,
    height: '100%',
    marginLeft: theme.spacing(2),
    backgroundColor: '#ffb400',
    borderColor: 'transparent',
    borderRadius: 4,
    color: '#fff',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e4a610',
    },
    '& > div': {
      padding: theme.spacing(0, 1),
    },
    '& > fieldset': {
      borderColor: 'transparent',
    },
  },
  selectItem: {
    padding: theme.spacing(1, 1.2),
    '& svg': {
      marginRight: theme.spacing(1.2),
    },
    '& img': {
      marginRight: theme.spacing(1.2),
    },
  },
  selectCheck: {
    padding: theme.spacing(0),
  },
  btn: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(2),
  },
  btnAdd: {
    textTransform: 'capitalize',
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    backgroundColor: '#5081FF',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  iconBtn: {
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginRight: theme.spacing(2),
  },
  filterBtn: {
    width: 160,
    height: '100%',
    padding: theme.spacing(0, 3),
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    boxShadow: theme.shadows[0],
    marginLeft: theme.spacing(5),
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
  },
  inputWide: {
    width: 300,
    flexGrow: 1,
    backgroundColor: '#fff',
    padding: theme.spacing(0, 2),
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
}));
